"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageFilterEditModal = void 0;
var react_1 = __importStar(require("react"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var TemplatesSelector_1 = require("Common/Templates/TemplatesSelector");
var TagsSelector_1 = require("Common/PageFilters/TagsSelector");
var ReportsPageSetFilter_1 = require("Reports/ReportsPageSetFilter/ReportsPageSetFilter");
var TwoPanelSettingsModal_1 = require("Library/TwoPanelSettingsModal");
var PageFilters = function (_a) {
    var pageFilter = _a.pageFilter, handleChange = _a.handleChange;
    return (react_1.default.createElement("div", { className: "page-filters-container" },
        react_1.default.createElement(TemplatesSelector_1.TemplatesSelector, { selectedTemplates: pageFilter.templateIds, setSelectedTemplates: function (newSelection) { return handleChange(__assign(__assign({}, pageFilter), { templateIds: newSelection })); } }),
        react_1.default.createElement(TagsSelector_1.TagsSelector, { selectedTags: pageFilter.tags, setSelectedTags: function (newSelection) { return handleChange(__assign(__assign({}, pageFilter), { tags: newSelection })); } }),
        react_1.default.createElement(ReportsPageSetFilter_1.PageWithSelect, { selectedPageWidth: pageFilter.pageWith, onSelect: function (value) { return handleChange(__assign(__assign({}, pageFilter), { pageWith: value })); } })));
};
function PageFilterEditModal(_a) {
    var _this = this;
    var closeModal = _a.closeModal, onApply = _a.onApply, existingFilters = _a.existingFilters;
    var _b = __read((0, react_1.useState)(existingFilters), 2), pageFilter = _b[0], setPageFilter = _b[1];
    var onApplyClick = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, onApply(pageFilter)];
                case 1:
                    _a.sent();
                    return [2, true];
            }
        });
    }); };
    return (react_1.default.createElement(TwoPanelSettingsModal_1.TwoPanelSettingsModal, { itemNoun: "collection", onApply: onApplyClick, onClose: closeModal, hasUnsavedChanges: function () { return !(0, isEqual_1.default)(pageFilter, existingFilters); }, hasValidInputs: function () { return true; }, left: react_1.default.createElement(kaleidoscope_1.Text, { align: "left" },
            react_1.default.createElement("p", { className: "space-stack-m" }, "Use filters to customise the parameters of this Collection."),
            react_1.default.createElement("p", null, "Filters help refine the type of pages you want in each collection. If you don't have any pages created from templates, use the Tag filter option instead, or rely on the 'Has content' filter by choosing which type of Page content you want to filter by.")), right: react_1.default.createElement(PageFilters, { pageFilter: pageFilter, handleChange: function (newPageFilter) { return setPageFilter(__assign({}, newPageFilter)); } }) }));
}
exports.PageFilterEditModal = PageFilterEditModal;
